module.exports = __webpack_public_path__ + "static/txtling2-768x1167-dbee74e03972c7b8671ebb7eecfe1061.png";